import {neverland as $, render, html, useState, useEffect} from 'neverland';
import Select from './Select.js';

function isInteger(value) {
	return /^\d+$/.test(value);
}

function fixType(value) {
	if (value == "true") {
		return true;
	} else if (value == "false") {
		return false;
	} else if (isInteger(value)) {
		return Number(value);
	} else {
		return value;
	}
}

const SelectField = $(function(f, fields, doc, updateDoc, collection, isViewMode = false) {

	function updateField(newVal) {

		if (fields[f].multiple) {
			newVal = newVal.map(v => fixType(v));
		} else {
			newVal = fixType(newVal);
		}

		updateDoc(f, newVal);
	}

	return html`
		${isViewMode ? html`
			<div class="select-field-view">
				${fields[f].multiple 
					? doc.curr[f].map(val => {
						const option = fields[f].options.find(opt => opt.value === val);
						return html`<span class="jellybean">${option ? option.label : val}</span>`;
					})
					: (() => {
						const option = fields[f].options.find(opt => opt.value === doc.curr[f]);
						return option ? option.label : doc.curr[f];
					})()
				}
			</div>
		` : Select(
			fields[f].options,
			doc.curr[f],
			updateField,
			fields[f].groupByCollection,
			fields[f].optionCollections,
			fields[f].searchEnabled,
			fields[f].multiple,
			fields[f].hideOptions)}
		<label>${fields[f].title}</label>
	`;

});

export default SelectField;